import PropTypes from 'prop-types';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import _ from 'lodash';

export { TableBody, TableHead, TableRow, TableCell };

const StyledTable = ({ children }) => (
  <div className="module-table">
    <MuiTable className="appointment-table">{children}</MuiTable>
  </div>
);

StyledTable.propTypes = {
  children: PropTypes.node.isRequired,
};

export const GlobalTable = ({ headers, renderRows }) => (
  <StyledTable>
    <TableHead>
      <TableRow>
        {_.map(headers, (header, i) => (
          <TableCell key={i}>{header}</TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>{renderRows}</TableBody>
  </StyledTable>
);

GlobalTable.propTypes = {
  headers: PropTypes.array.isRequired,
  renderRows: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default StyledTable;
